import { render, staticRenderFns } from "./ApprovalProgressQuery.vue?vue&type=template&id=22a7e2e3&scoped=true&"
import script from "./ApprovalProgressQuery.vue?vue&type=script&lang=js&"
export * from "./ApprovalProgressQuery.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalProgressQuery.vue?vue&type=style&index=0&id=22a7e2e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7e2e3",
  null
  
)

export default component.exports